import { createRouter, createWebHashHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [
  {
    path: "/",
    name: 'Home',
    redirect: { 
      path: '/1',
    },
  },
  {
    path: '/:page',
    name: 'Page',
    component: Home,
    props: (route) => ({
      ...route.params
    })
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;